import React, { useEffect, useState } from 'react';
import { FormControlLabel, Switch } from "@mui/material";
import { useAgencyInfo } from "context/agency";

const PrivateApps = ({ formData }) => {
    const [allowedApps, setAllowedApps] = useState([]);
   

    useEffect(() => {
        // Initialize the allowed apps with the formData.apps on component mount
        setAllowedApps(formData || []);
    }, [formData]);

    

    return (
        <div>
            {allowedApps.map((item, index) => (
                <div
                    key={index}
                    style={{
                        marginBottom: "10px",
                        borderRadius: '10px',
                        border: "1px solid rgba(229, 229, 229, 1)",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between"
                    }}
                >
                    <p className="px-5-dd text-left font-bold" style={{ width: "25%" }}>{item}</p>
                    
                </div>
            ))}
        </div>
    );
};

export default PrivateApps;
